<template>
    <div class="lg:w-10/12 mx-auto mt-10">
        <Stepper :current-step="2" />

        <div class="mb-16 flex flex-col gap-6 lg:flex-row lg:gap-10">
            <div class="w-full lg:w-8/12">
                <Fieldset>
                    <AddOnsList
                        :add-ons="cartAddOnsStore.addOns"
                        :get-value="(addOn) => cartStore.getAddOnValue(addOn)"
                        :on-change="
                            (addOn, payload) =>
                                cartStore.updateCartAddOn({
                                    add_on_id: addOn.id,
                                    ...normalizeAddOnPayload(payload)
                                })
                        "
                    />
                </Fieldset>
                <a href="/checkout/" class="btn btn-lg btn-primary w-full mt-6 hidden! lg:flex!">
                    {{ $t('Continue to customer information') }}
                </a>
            </div>

            <div class="lg:w-4/12 isolate">
                <div class="rounded-2xl border border-gray-200 shadow-custom-xl bg-white lg:sticky top-4 z-10">
                    <Summary />
                </div>
                <a href="/checkout/" class="btn btn-lg btn-primary w-full mt-6 flex! lg:hidden!">
                    {{ $t('Continue to customer information') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useCartAddOnsStore } from '@/stores/cartAddOns'
import { useCartStore } from '@/stores/cart'
import AddOnsList from './_partials/Index.vue'

const cartStore = useCartStore()
const cartAddOnsStore = useCartAddOnsStore()

const normalizeAddOnPayload = (payload) => {
    const isStructuredPayload = payload != null && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'value')

    return isStructuredPayload ? payload : { value: payload }
}

await cartStore.loadCart()

await cartAddOnsStore.loadAddOns()
</script>
